export default __webpack_public_path__ + "static/media/Cheddar.b712f5dc.jpg";